import React from 'react';
import PropTypes from 'prop-types';

import { Translate } from '@hydra/common/components';
import {
  Criterium,
  CriteriumText,
  CriteriumTable,
  CriteriumSkeleton,
  CriteriumIconAndText
} from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

const getHead = isError => {
  if (isError) {
    return [
      <Translate content='robots_tags_tag' key='robots_tags_tag' />,
      <Translate content='robots_tags_source' key='robots_tags_source' />,
      <Translate content='robots_tags_issue' key='robots_tags_issue' />
    ];
  }

  return [
    <Translate content='robots_tags_tag' key='robots_tags_tag' />,
    <Translate content='robots_tags_source' key='robots_tags_source' />
  ];
};

const getRows = tags => {
  return tags.map(({ snippet, error, source }) => {
    return [
      snippet,
      source !== 'HTML' ? 'HTTP header' : source,
      error && error.type ? <Translate content={`robots_tags_${error.type.toLowerCase()}`} /> : null
    ];
  });
};

export const RobotsTags = ({ criterium }) => {
  const { data } = criterium;
  const { tags, htmlHeaderDiscrepancy, hasDirectiveError } = data;
  const { variant } = useReviewContext();

  let text;
  if (tags.length > 0) {
    if (htmlHeaderDiscrepancy) {
      text = (
        <CriteriumIconAndText
          success={false}
          text={<Translate content='robots_tags_html_header_discrepancy' />}
        />
      );
    } else if (hasDirectiveError) {
      text = (
        <CriteriumIconAndText
          success={false}
          text={<Translate content='robots_tags_directives_error' />}
        />
      );
      if (data.tags.some(t => t.error?.type === 'CONFLICTING_DIRECTIVE')) {
        text = (
          <>
            <CriteriumIconAndText
              success={false}
              text={<Translate content='robots_tags_directives_error' />}
            />
            <p style={{ marginTop: '10px' }}>
              <CriteriumText
                firstLine={<Translate content='robots_tags_conflicting_message' />}
              />
            </p>
          </>
        );
      }
    } else {
      text = (
        <CriteriumIconAndText
          success
          text={<Translate content='robots_tags_valid' />}
        />
      );
    }
  } else {
    text = variant === 'nocrit' ? <CriteriumSkeleton width='70%' /> : <Translate content='robots_tags_no_tags' />;
  }

  return (
    <Criterium criterium={criterium}>
      {text}
      {tags.length > 0 && (
        <CriteriumTable
          head={getHead(hasDirectiveError)}
          rows={getRows(tags)}
          fixedColumns={hasDirectiveError ? [3, 1, 2] : [4, 1]}
          striped
        />
      )}
    </Criterium>
  );
};

RobotsTags.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      tags: PropTypes.array,
      htmlHeaderDiscrepancy: PropTypes.bool,
      hasDirectiveError: PropTypes.bool
    })
  })
};

export default React.memo(RobotsTags);
